import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.40625 1.9375H3.09375C3.55078 1.9375 3.9375 2.32422 3.9375 2.78125V4.46875C3.9375 4.96094 3.55078 5.3125 3.09375 5.3125H1.40625C0.914062 5.3125 0.5625 4.96094 0.5625 4.46875V2.78125C0.5625 2.32422 0.914062 1.9375 1.40625 1.9375ZM6.46875 2.78125H17.1562C17.6133 2.78125 18 3.16797 18 3.625C18 4.11719 17.6133 4.46875 17.1562 4.46875H6.46875C5.97656 4.46875 5.625 4.11719 5.625 3.625C5.625 3.16797 5.97656 2.78125 6.46875 2.78125ZM6.46875 8.40625H17.1562C17.6133 8.40625 18 8.79297 18 9.25C18 9.74219 17.6133 10.0938 17.1562 10.0938H6.46875C5.97656 10.0938 5.625 9.74219 5.625 9.25C5.625 8.79297 5.97656 8.40625 6.46875 8.40625ZM6.46875 14.0312H17.1562C17.6133 14.0312 18 14.418 18 14.875C18 15.3672 17.6133 15.7188 17.1562 15.7188H6.46875C5.97656 15.7188 5.625 15.3672 5.625 14.875C5.625 14.418 5.97656 14.0312 6.46875 14.0312ZM0.5625 8.40625C0.5625 7.94922 0.914062 7.5625 1.40625 7.5625H3.09375C3.55078 7.5625 3.9375 7.94922 3.9375 8.40625V10.0938C3.9375 10.5859 3.55078 10.9375 3.09375 10.9375H1.40625C0.914062 10.9375 0.5625 10.5859 0.5625 10.0938V8.40625ZM1.40625 13.1875H3.09375C3.55078 13.1875 3.9375 13.5742 3.9375 14.0312V15.7188C3.9375 16.2109 3.55078 16.5625 3.09375 16.5625H1.40625C0.914062 16.5625 0.5625 16.2109 0.5625 15.7188V14.0312C0.5625 13.5742 0.914062 13.1875 1.40625 13.1875Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgListDark);
export { ForwardRef as ReactComponent };
